module.exports = __webpack_public_path__ + "static/img/produto_g.98e6d04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/antares-cgas/produto_g.png
// module id = fyir
// module chunks = 0